/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {lookupTokenType} from '../api'

export const useMutationLookupTokenType = createReactQueryMutationHook('lookupTokenType', lookupTokenType)
